import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";
import LicenseChecker from "~/areas/insights/components/InsightsRoutes/LicenseChecker";
import { useEnabledFeatureToggle } from "~/components/FeatureToggle/New/FeatureToggleContext";
import InternalRedirect from "~/components/Navigation/InternalRedirect";
import { withPage } from "~/components/Page/Page";
import ReloadableRoute from "~/components/ReloadableRoute/ReloadableRoute";
import pageIds from "~/pageIds";
import routeLinks from "../../../../routeLinks";
import { InsightsReportLayout } from "../InsightsReportLayout/InsightsReportLayout";
import { ReportDeploymentFailureRate } from "../Reports/ReportDeploymentFailureRate";
import { ReportDeploymentFrequency } from "../Reports/ReportDeploymentFrequency";
import { ReportDeploymentLeadTime } from "../Reports/ReportDeploymentLeadTime";
import { ReportList } from "../Reports/ReportList/ReportList";
import { ReportMeanTimeToRecovery } from "../Reports/ReportMeanTimeToRecovery";
import { ReportOverview } from "../Reports/ReportOverview/ReportOverview";
import { ReportSettings } from "../Reports/ReportSettings";

const InsightsReportListPage = withPage({ page: pageIds.insights.reports })(ReportList);
const InsightsReportOverviewPage = withPage({ page: pageIds.insights.report.overview })(ReportOverview);
const InsightsReportDeploymentFrequencyPage = withPage({ page: pageIds.insights.report.frequency })(ReportDeploymentFrequency);
const InsightsReportDeploymentLeadTimePage = withPage({ page: pageIds.insights.report.leadTime })(ReportDeploymentLeadTime);
const InsightsReportDeploymentFailureRatePage = withPage({ page: pageIds.insights.report.failureRate })(ReportDeploymentFailureRate);
const InsightsReportDeploymentMeanTimeToRecoveryPage = withPage({ page: pageIds.insights.report.timeToRecovery })(ReportMeanTimeToRecovery);
const InsightsReportSettingsPage = withPage({ page: pageIds.insights.report.settings })(ReportSettings);

const InsightsRoutes = () => {
    const isInsightsToggleEnabled = useEnabledFeatureToggle("InsightsFeatureToggle");
    const isInsightsEapEnabled = useSelector((state: GlobalState) => state.configurationArea.features.isInsightsEapEnabled);

    const reportLinks = routeLinks.insights.report(":reportId");

    if (!isInsightsEapEnabled || !isInsightsToggleEnabled) return <InternalRedirect to={routeLinks.root} />;

    return (
        <Switch>
            <ReloadableRoute path={routeLinks.insights.root}>
                <LicenseChecker>
                    <Switch>
                        <ReloadableRoute path={routeLinks.insights.reports} exact component={InsightsReportListPage} />
                        <ReloadableRoute path={reportLinks.root}>
                            <InsightsReportLayout>
                                {({ report, refreshReport }) => (
                                    <Switch>
                                        <ReloadableRoute path={reportLinks.overview} render={() => <InsightsReportOverviewPage report={report} />} />
                                        <ReloadableRoute path={reportLinks.frequency} exact render={() => <InsightsReportDeploymentFrequencyPage report={report} />} />
                                        <ReloadableRoute path={reportLinks.leadTime} exact render={() => <InsightsReportDeploymentLeadTimePage report={report} />} />
                                        <ReloadableRoute path={reportLinks.failureRate} exact render={() => <InsightsReportDeploymentFailureRatePage report={report} />} />
                                        <ReloadableRoute path={reportLinks.timeToRecovery} exact render={() => <InsightsReportDeploymentMeanTimeToRecoveryPage report={report} />} />
                                        <ReloadableRoute path={reportLinks.settings} exact render={() => <InsightsReportSettingsPage report={report} refreshReport={refreshReport} />} />
                                    </Switch>
                                )}
                            </InsightsReportLayout>
                        </ReloadableRoute>
                    </Switch>
                </LicenseChecker>
            </ReloadableRoute>
        </Switch>
    );
};

export default InsightsRoutes;
